import { render, staticRenderFns } from "./PanelCTAs.vue?vue&type=template&id=e58ba44a&lang=pug"
import script from "./PanelCTAs.vue?vue&type=script&lang=ts"
export * from "./PanelCTAs.vue?vue&type=script&lang=ts"
import style0 from "./PanelCTAs.vue?vue&type=style&index=0&id=e58ba44a&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TrustPilotWidget: require('/app/components/generic/TrustPilotWidget.vue').default,Btn: require('/app/components/vantone/Btn.vue').default,Icon: require('/app/components/vantone/Icon.vue').default})
